module.exports = __webpack_public_path__ + "img/KinokoTable65.dfebcd26.jpg";